var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOptionCheckmarkChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55026 11.323C6.37127 11.144 6.37127 10.8538 6.55026 10.6748C6.72925 10.4958 7.01945 10.4958 7.19844 10.6748L9.62435 13.1007L14.8003 7.92477C14.9792 7.74578 15.2695 7.74578 15.4484 7.92477C15.6274 8.10376 15.6274 8.39396 15.4484 8.57295L9.94844 14.073C9.76945 14.2519 9.47925 14.2519 9.30026 14.073L6.55026 11.323Z",
    fill: "#AB38FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4467 7.57122C14.821 7.19696 15.4277 7.19696 15.802 7.57122C16.1762 7.94547 16.1762 8.55225 15.802 8.9265L10.302 14.4265C9.92774 14.8008 9.32096 14.8008 8.94671 14.4265L6.1967 11.6765C5.82245 11.3023 5.82245 10.6955 6.1967 10.3212C6.57096 9.94696 7.17774 9.94696 7.55199 10.3212L9.62435 12.3936L14.4467 7.57122Z",
    fill: "#6DBC81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOptionCheckmarkChecked);
export default __webpack_public_path__ + "static/media/ic_option_checkmark_checked.e176b4f15fe68f917365518532fc137b.svg";
export { ForwardRef as ReactComponent };